export function getAll() {
  return [
    {
      value: 0,
      name: "0",
      text: "0天",
    },
    {
      value: 1,
      name: "1",
      text: "1天",
    },
    {
      value: 2,
      name: "2",
      text: "2天",
    },
    {
      value: 3,
      name: "3",
      text: "3天",
    },
    {
      value: 4,
      name: "4",
      text: "4天",
    },
    {
      value: 5,
      name: "5",
      text: "5天",
    },
    {
      value: 6,
      name: "6",
      text: "6天",
    },
    {
      value: 7,
      name: "7",
      text: "7天",
    },
    {
      value: 8,
      name: "8",
      text: "8天",
    },
    {
      value: 9,
      name: "9",
      text: "9天",
    },
    {
      value: 10,
      name: "10",
      text: "10天",
    },
    {
      value: 11,
      name: "11",
      text: "11天",
    },
    {
      value: 12,
      name: "12",
      text: "12天",
    },
    {
      value: 13,
      name: "13",
      text: "13天",
    },
    {
      value: 14,
      name: "14",
      text: "14天",
    },
    {
      value: 15,
      name: "15",
      text: "15天",
    },
    {
      value: 16,
      name: "16",
      text: "16天",
    },
    {
      value: 17,
      name: "17",
      text: "17天",
    },
    {
      value: 18,
      name: "18",
      text: "18天",
    },
    {
      value: 19,
      name: "19",
      text: "19天",
    },
    {
      value: 20,
      name: "20",
      text: "20天",
    },
    {
      value: 21,
      name: "21",
      text: "21天",
    },
    {
      value: 22,
      name: "22",
      text: "22天",
    },
    {
      value: 23,
      name: "23",
      text: "23天",
    },
    {
      value: 24,
      name: "24",
      text: "24天",
    },
    {
      value: 25,
      name: "25",
      text: "25天",
    },
    {
      value: 26,
      name: "26",
      text: "26天",
    },
    {
      value: 27,
      name: "27",
      text: "27天",
    },
    {
      value: 28,
      name: "28",
      text: "28天",
    },
    {
      value: 29,
      name: "29",
      text: "29天",
    },
    {
      value: 30,
      name: "30",
      text: "30天",
    },
    {
      value: 31,
      name: "31",
      text: "31天",
    },
  ];
}

export function getBirthDay(month) {
  let days = [
    {
      value: 1,
      name: "01",
      text: "1日",
    },
    {
      value: 2,
      name: "02",
      text: "2日",
    },
    {
      value: 3,
      name: "03",
      text: "3日",
    },
    {
      value: 4,
      name: "04",
      text: "4日",
    },
    {
      value: 5,
      name: "05",
      text: "5日",
    },
    {
      value: 6,
      name: "06",
      text: "6日",
    },
    {
      value: 7,
      name: "07",
      text: "7日",
    },
    {
      value: 8,
      name: "08",
      text: "8日",
    },
    {
      value: 9,
      name: "09",
      text: "9日",
    },
    {
      value: 10,
      name: "10",
      text: "10日",
    },
    {
      value: 11,
      name: "11",
      text: "11日",
    },
    {
      value: 12,
      name: "12",
      text: "12日",
    },
    {
      value: 13,
      name: "13",
      text: "13日",
    },
    {
      value: 14,
      name: "14",
      text: "14日",
    },
    {
      value: 15,
      name: "15",
      text: "15日",
    },
    {
      value: 16,
      name: "16",
      text: "16日",
    },
    {
      value: 17,
      name: "17",
      text: "17日",
    },
    {
      value: 18,
      name: "18",
      text: "18日",
    },
    {
      value: 19,
      name: "19",
      text: "19日",
    },
    {
      value: 20,
      name: "20",
      text: "20日",
    },
    {
      value: 21,
      name: "21",
      text: "21日",
    },
    {
      value: 22,
      name: "22",
      text: "22日",
    },
    {
      value: 23,
      name: "23",
      text: "23日",
    },
    {
      value: 24,
      name: "24",
      text: "24日",
    },
    {
      value: 25,
      name: "25",
      text: "25日",
    },
    {
      value: 26,
      name: "26",
      text: "26日",
    },
    {
      value: 27,
      name: "27",
      text: "27日",
    },
    {
      value: 28,
      name: "28",
      text: "28日",
    },
    {
      value: 29,
      name: "29",
      text: "29日",
    },
    {
      value: 30,
      name: "30",
      text: "30日",
    },
    {
      value: 31,
      name: "31",
      text: "31日",
    },
  ];
  if (month == "02") {
    days.splice(28, 3);
  }
  if (month == "04" || month == "06" || month == "09" || month == "11") {
    days.splice(30, 1);
  }
  return days;
}
